import InstallWebPackageManagers from "../../../../contents/docs/integrate/_snippets/install-web-package-managers.mdx";
import Tab from "components/Tab";
import CompositionInstall from "../../../../contents/docs/integrate/_snippets/vuejs/composition-install.mdx";
import PluginInstall from "../../../../contents/docs/integrate/_snippets/vuejs/plugin-install.mdx";
import * as React from 'react';
export default {
  InstallWebPackageManagers,
  Tab,
  CompositionInstall,
  PluginInstall,
  React
};